import React from 'react'

const NavArrow = () => (
  <svg width={16} height={29} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m2 27 10.67-11.115a2 2 0 0 0 0-2.77L2 2" stroke="#37190C" strokeWidth={5} />
  </svg>
)

export default NavArrow
